import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
  const isAuth = useSelector((state) => state.auth.isAuthorized);
  const location = useLocation();

  if (!isAuth) {
    const prev = sessionStorage.getItem('previousPath');
    if (!prev) {
      const full = `${location.pathname}${location.search || ''}${location.hash || ''}`;
      sessionStorage.setItem('previousPath', full);
    }
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

export default PrivateRoute;
